<template>
  <div class="variable-selector">
    <!--<label v-if="label">{{ label }}</label>-->
    <b-form-radio-group
      button-variant="primary"
      id="radio-group-mode"
      v-model="processType"
      size="lg"
      class="processTypeList"
      buttons
      placeholder="Feldolgozási mód"
      v-show="viewType == 'mapView'"
    >
      <b-form-radio
        v-for="processTypeElement in process_type_list"
        :key="processTypeElement.symbol"
        :value="processTypeElement.symbol"
        :disabled="processTypeElement.disabled"
        :title="processTypeElement.tooltip"
        v-b-tooltip.hover
        >{{ processTypeElement.label }}</b-form-radio
      >
    </b-form-radio-group>
  </div>
</template>

<script>
import { watch } from "vue";

export default {
  name: "PocessTypeSelector",
  props: {
    variableMap: {
      type: Map,
      default: () => new Map(),
    },
    value: {
      type: String,
      default: "",
    },
    viewType: {
      type: String,
      default: "mapView",
    },
    modelType: {
      type: String,
      default: "climate",
    },
    variableNotation: {
      type: String,
      default: "",
    },
    dateRangeStart: {
      type: Number,
      default: 1991,
    },
  },
  data() {
    return {
      selectedVariable: this.value,
      processType: this.value,
    };
  },
  computed: {
    currentYear() {
      let date = new Date();
      return date.getFullYear();
    },
    /*variableList() {
      let viewType = this.viewType;
      let modelType = this.modelType;
      console.log(this.variableMap);
      if (this.variableMap.has("mapView")) {
        let localVariableMap = this.variableMap.get(viewType).get(modelType);
        if (!localVariableMap.has(this.selectedVariable)) {
          this.selectedVariable = null;
        }
        return Array.from(localVariableMap.values());
      }
    },*/
    process_type_list: function () {
      let variableNotation = this.variableNotation;
      let viewType = this.viewType;
      let modelType = this.modelType;
      if (!variableNotation || !modelType || !viewType) {
        if (modelType == "climate")
          return [
            {
              symbol: "o",
              label: "Megfigyelés",
              disabled: true,
              tooltip: "A mérésekből előállított adatok az 1971–2025 időszakon",
            },
            {
              symbol: "p",
              label: "Valószínűség",
              disabled: true,
              tooltip:
                "Jövőre vonatkozó modelleredmények megjelenítési módja: adott küszöbértéket meghaladó változás valószínűsége a 2021–2100 időszakon",
            },
            {
              symbol: "q",
              label: "Kvantilis",
              disabled: true,
              tooltip:
                "Jövőre vonatkozó modelleredmények megjelenítési módja: várható jövőbeli értékek vagy változások kvantilis értékei a 2026–2100 időszakon",
            },
          ];
        else
          return [
            {
              symbol: "o",
              label: "Megfigyelés",
              disabled: true,
              tooltip: "A mérésekből előállított adatok az 1971–2025 időszakon",
            },
            {
              symbol: "p",
              label: "Valószínűség",
              disabled: true,
              tooltip:
                "Jövőre vonatkozó modelleredmények megjelenítési módja: adott küszöbértéket meghaladó változás valószínűsége a 2021–2100 időszakon",
            },
            {
              symbol: "q",
              label: "Kvantilis",
              disabled: true,
              tooltip:
                "Jövőre vonatkozó modelleredmények megjelenítési módja: várható jövőbeli értékek vagy változások kvantilis értékei a 2026–2100 időszakon",
            },
          ];
      }
      let variableObject = this.variableMap
        .get(viewType)
        .get(modelType)
        .get(variableNotation);
      let type_list = [];
      let enabledSymbolArray = [];
      //Itt kellene város mód esetén kihagyni a valószínűséget
      let megfigyelesTooltip;
      if (modelType == "climate") {
        megfigyelesTooltip =
          "A mérésekből előállított adatok az 1971–2025 időszakon";
      } else {
        megfigyelesTooltip =
          "A mérésekből előállított adatok az 1971–2025 időszakon";
      }
      if (this.dateRangeStart <= this.currentYear - 29) {
        type_list.push({
          symbol: "o",
          label: "Megfigyelés",
          tooltip: megfigyelesTooltip,
        });
        enabledSymbolArray.push("o");

        type_list.push({
          symbol: "p",
          label: "Valószínűség",
          disabled: true,
          tooltip:
            "Jövőre vonatkozó modelleredmények megjelenítési módja: adott küszöbértéket meghaladó változás valószínűsége a 2026–2100 időszakon",
        });
        type_list.push({
          symbol: "q",
          label: "Kvantilis",
          disabled: true,
          tooltip:
            "Jövőre vonatkozó modelleredmények megjelenítési módja: várható jövőbeli értékek vagy változások kvantilis értékei a 2026–2100 időszakon",
        });
      } else {
        type_list.push({
          symbol: "o",
          label: "Megfigyelés",
          disabled: true,
          tooltip: megfigyelesTooltip,
        });
        if (variableObject.processing_p_type) {
          type_list.push({
            symbol: "p",
            label: "Valószínűség",
            tooltip:
              "Jövőre vonatkozó modelleredmények megjelenítési módja: adott küszöbértéket meghaladó változás valószínűsége a 2026–2100 időszakon",
          });
          enabledSymbolArray.push("p");
        } else {
          if (modelType == "climate")
            type_list.push({
              symbol: "p",
              label: "Valószínűség",
              disabled: true,
              tooltip:
                "Jövőre vonatkozó modelleredmények megjelenítési módja: adott küszöbértéket meghaladó változás valószínűsége a 2026–2100 időszakon",
            });
        }
        if (variableObject.processing_q_type) {
          type_list.push({
            symbol: "q",
            label: "Kvantilis",
            tooltip:
              "Jövőre vonatkozó modelleredmények megjelenítési módja: várható jövőbeli értékek vagy változások kvantilis értékei a 2026–2100 időszakon",
          });
          enabledSymbolArray.push("q");
        } else {
          type_list.push({
            symbol: "q",
            label: "Kvantilis",
            disabled: true,
            tooltip:
              "Jövőre vonatkozó modelleredmények megjelenítési módja: várható jövőbeli értékek vagy változások kvantilis értékei a 2026–2100 időszakon",
          });
        }
      }
      if (!enabledSymbolArray.includes(this.processType)) {
        console.log("Enabled symbols:", enabledSymbolArray);
        if (enabledSymbolArray.includes("q")) this.processType = "q";
        else this.processType = enabledSymbolArray[0];
      }
      return type_list;
    },
  },
  watch: {
    value(newVal) {
      this.processType = newVal;
    },
    processType(newVal) {
      console.log("emitting process type:", newVal);
      this.$emit("input", newVal);
    },
    /*selectedVariable(newVal) {
      this.$emit("input", newVal);
    },*/
  },
  methods: {
    onChange() {
      this.$emit("input", this.processType);
    },
  },
};
</script>

<style scoped>
.variable-selector {
  margin-bottom: 1rem;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
}

.variable-select {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: white;
  font-size: 1rem;
}
</style>
